var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartreach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sr1",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671.429 442.857c-63.119 0-114.286-51.167-114.286-114.286 0-63.118 51.167-114.285 114.286-114.285 63.118 0 114.285 51.167 114.285 114.285 0 63.119-51.167 114.286-114.285 114.286zM3.423 558.571c-6.905-59.516-23.46-285.799 188.665-452.507C404.212-60.645 643.846 11.609 698.57 41.252 580.77 98 403.243 230.339 286.328 393.01 88.988 430.248 3.423 558.57 3.423 558.57zM441.43 996.577s128.323-85.564 165.56-282.905C769.661 596.757 902 419.23 958.75 301.43c29.642 54.725 101.896 294.36-64.813 506.483-166.708 212.124-392.991 195.57-452.507 188.665zM20.662 642.857s138.939 17.933 193.624 71.429L100 800c-57.983-76.783-79.338-157.143-79.338-157.143zm336.48 336.483s-89.028-23.637-165.713-86.483l94.285-107.143c56.507 74.445 71.429 156.427 71.429 193.626z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#sr1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M-186.294 238.37l947.524 947.524-141.422 141.42-947.523-947.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6E00",
    d: "M-44.872 96.95l947.523 947.522-141.421 141.422-947.524-947.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9100",
    d: "M96.55-44.472l947.522 947.523-141.421 141.421L-44.872 96.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC300",
    d: "M237.97-185.894l947.524 947.524-141.422 141.42L96.55-44.471z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE100",
    d: "M379.392-327.315l947.523 947.523-141.421 141.422L237.97-185.894z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFCD00",
    mask: "url(#sr1)",
    cx: 671.429,
    cy: 328.571,
    r: 114.286
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartreach);
export default __webpack_public_path__ + "static/media/smartreach.a4615c4ebbec1af2b60d350d6e29e2c6.svg";
export { ForwardRef as ReactComponent };